import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { User } from '../types/auth';

// Export BusinessRole for backward compatibility if needed
export interface BusinessRole {
    userId: string;
    businessId: string;
    role: string;
    isBusinessAdmin: boolean;
}

// Re-export User type from auth.ts for convenience
export type { User };

export const useAuth = () => {
    return useContext(AuthContext);
}; 